// Studyo Today Backend
// Package studyo.today.planners.v1
// Service definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/planner_schedules.proto (package studyo.today.planners.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schedules_v1_resources_schedule_cycle } from "@buf/studyo_studyo-today-schedules.bufbuild_es/studyo/today/schedules/v1/resources/schedule_cycle_pb.js";

/**
 * Describes the file studyo/today/planners/v1/planner_schedules.proto.
 */
export const file_studyo_today_planners_v1_planner_schedules = /*@__PURE__*/
  fileDesc("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", [file_studyo_today_schedules_v1_resources_schedule_cycle]);

/**
 * Describes the message studyo.today.planners.v1.GetScheduleCycleRequest.
 * Use `create(GetScheduleCycleRequestSchema)` to create a new message.
 */
export const GetScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 0);

/**
 * Describes the message studyo.today.planners.v1.GetScheduleCycleResponse.
 * Use `create(GetScheduleCycleResponseSchema)` to create a new message.
 */
export const GetScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 1);

/**
 * Describes the message studyo.today.planners.v1.PublishInitialScheduleCycleRequest.
 * Use `create(PublishInitialScheduleCycleRequestSchema)` to create a new message.
 */
export const PublishInitialScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 2);

/**
 * Describes the message studyo.today.planners.v1.PublishInitialScheduleCycleResponse.
 * Use `create(PublishInitialScheduleCycleResponseSchema)` to create a new message.
 */
export const PublishInitialScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 3);

/**
 * Describes the message studyo.today.planners.v1.SaveDraftScheduleCycleRequest.
 * Use `create(SaveDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const SaveDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 4);

/**
 * Describes the message studyo.today.planners.v1.SaveDraftScheduleCycleResponse.
 * Use `create(SaveDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const SaveDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 5);

/**
 * Describes the message studyo.today.planners.v1.PublishDraftScheduleCycleRequest.
 * Use `create(PublishDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const PublishDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 6);

/**
 * Describes the message studyo.today.planners.v1.PublishDraftScheduleCycleResponse.
 * Use `create(PublishDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const PublishDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 7);

/**
 * Describes the message studyo.today.planners.v1.DiscardLastDraftScheduleCycleRequest.
 * Use `create(DiscardLastDraftScheduleCycleRequestSchema)` to create a new message.
 */
export const DiscardLastDraftScheduleCycleRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 8);

/**
 * Describes the message studyo.today.planners.v1.DiscardLastDraftScheduleCycleResponse.
 * Use `create(DiscardLastDraftScheduleCycleResponseSchema)` to create a new message.
 */
export const DiscardLastDraftScheduleCycleResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 9);

/**
 * Describes the message studyo.today.planners.v1.DiscardAllDraftScheduleCyclesRequest.
 * Use `create(DiscardAllDraftScheduleCyclesRequestSchema)` to create a new message.
 */
export const DiscardAllDraftScheduleCyclesRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 10);

/**
 * Describes the message studyo.today.planners.v1.DiscardAllDraftScheduleCyclesResponse.
 * Use `create(DiscardAllDraftScheduleCyclesResponseSchema)` to create a new message.
 */
export const DiscardAllDraftScheduleCyclesResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_planner_schedules, 11);

/**
 * Service definition for the Today API.
 *
 * @generated from service studyo.today.planners.v1.PlannerSchedules
 */
export const PlannerSchedules = /*@__PURE__*/
  serviceDesc(file_studyo_today_planners_v1_planner_schedules, 0);

